import * as DocumentsActions from "./documents.actions";

import {createReducer, on} from "@ngrx/store";
import {EntityCategoryTreePrev} from '@common/components-standalone/reference-category-module/category.type';
import {SetAllInitialStates} from '@common/store/actions/core.actions';

export const documentsFeatureKey = 'documents';

export interface DocumentsState {
    categories: EntityCategoryTreePrev[],
    categoriesLoading: boolean
}

export const initialState: DocumentsState = {
    categories: [],
    categoriesLoading: true,
};

export const documentsReducer = createReducer(
    initialState,

    on(DocumentsActions.LoadCategories, (state) => {
        return {
            ...state,
            ...!state.categories?.length && {categoriesLoading: true}
        };
    }),

    on(DocumentsActions.LoadCategoriesSuccess, (state, action) => {
        return {
            ...state,
            categories: action.categories,
            categoriesLoading: false
        };
    }),

    on(DocumentsActions.LoadCategoriesFailure, (state) => {
        return {
            ...state,
            categoriesLoading: false
        };
    }),

    on(SetAllInitialStates, () => ({...initialState}))
);
